import React, { useState } from "react";
import { Alert, Box, Button } from "@mui/material";
import ProgressStepper from "./ProgressStepper";
import { getStepAfterClick, saveItemProgress } from "./ItemProgress";

export default function ItemProgressTracker(props) {
  const { orderId, item, itemIndex, progress, onChange } = props;

  const [activeStep, setActiveStep] = useState(progress.step);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleCancel = () => {
    setActiveStep(progress.step);
    setError("");
  };

  const updateProgress = () => {
    setSaving(true);
    setError("");
    saveItemProgress(orderId, itemIndex, item, { step: activeStep, steps: progress.steps })
      .then((res) => {
        if (onChange) {
          onChange(res.data);
        }
      })
      .catch((err) => {
        setError(err.response?.data?.message || "An error occurred while saving progress");
      })
      .finally(() => setSaving(false));
  };

  return (
    <Box>
      <Box my={2}>
        <ProgressStepper
          orientation="vertical"
          steps={progress.steps}
          activeStep={activeStep}
          onStepClick={(step) => setActiveStep(getStepAfterClick(step, progress.step))}
        />
      </Box>
      {error && <Alert severity="error">{error}</Alert>}
      {activeStep !== progress.step && (
        <Box sx={{ display: "flex", gap: 1.5 }}>
          <Button
            fullWidth
            color="secondary"
            variant="outlined"
            onClick={handleCancel}
            disabled={saving}
          >
            CANCEL
          </Button>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={updateProgress}
            disabled={saving}
          >
            SAVE CHANGES
          </Button>
        </Box>
      )}
    </Box>
  );
}
